export const ManageImages = {
  ascending: require('./ascending.svg'),
  descending: require('./descending.svg'),
  filter: require('./filter.svg'),
  refresh: require('./refresh.svg'),
  folders: require('./folders.svg'),
  calendar: require('./calendar.svg'),
  android: require('./android.svg'),
  apple: require('./apple.svg'),
  slack: require('./slack.svg'),
  cyphlens: require('./cyphlens.svg'),
  favorites: require('./favorites.svg'),
  dashboard: require('./dashboard.svg'),
  share: require('./share.svg'),
  star: require('./star.svg'),
  starFilled: require('./starFilled.svg'),
  delete: require('./delete.svg'),
  api: require('./api.svg'),
  teams: require('./teams.svg'),
  mobile: require('./mobile.svg'),
  activity: require('./activity.svg'),
};
